import React from 'react';
import { Grid, GridColumn, Typography, Button, Box } from '@kohler-dsm-library/kohler-core';
import styles from '../productFeatureCarousel.module.css';

const buttonProps = {
  variant: 'brand',
  size: 'large',
};

export default function Header({ eyebrow, title, description, ctaItems = [] }) {
  const hasCTA = ctaItems && ctaItems.length > 0;

  return (
    <Box className={styles.headerWrapper}>
      {/* Eyebrow */}
      {eyebrow && (
        <Typography size="label-medium-m" component="p" className={styles.headerEyebrow}>
          {eyebrow}
        </Typography>
      )}

      {/* Title */}
      {title && (
        <Typography size="h2" className={styles.headerTitle}>
          {title}
        </Typography>
      )}

      {/* Description + CTA Row */}
      <Grid className={styles.headerBottomRowGrid}>
        <GridColumn span={9} spanSmall={12}>
          {/* Description */}
          {description && (
            <Typography size="paragraph-large" component="p" className={styles.headerDescription}>
              {description}
            </Typography>
          )}
        </GridColumn>
        {/* CTA */}
        <GridColumn span={3} spanSmall={12}>
          {hasCTA &&
            ctaItems.map((cta, i) => (
              <Button className={styles.ctaButton} {...buttonProps} href={cta.link} key={i}>
                {cta.label}
              </Button>
            ))}
        </GridColumn>
      </Grid>
    </Box>
  );
}
